import { appendBasePath } from 'common/navUtils';
import { ATBeaconButton } from 'components/common/beacon/beaconRegistration';
import React from 'react';
import { useSelector } from 'react-redux';
import ErrorIcon from 'src/components/common/icons/Error';
import { RootState } from 'src/state/store';
import { CTAVariants } from '@trp-beacon-ui-kit/foundation/dist/_common/types/cta-variant';
import './Pershing.scss';

export default function PershingErrorpage() {
  const contactUsUrl = useSelector((state: RootState) => state.appConfig.contactUsUrl);
  return (
    <div className="layout-section pershing-error-page" data-testid="pershing-error-page">
      <ErrorIcon className="error-icon" />
      <label className="b-typography-serif--headline--500 b-font-weight-bold error-message">
        Your transaction could not be processed at this time.
      </label>
      <span className="b-typography-sans-serif--body--200 b-font-weight-light">
        Please{' '}
        <a className="pershing-try-again" href={appendBasePath('/')}>
          try again
        </a>
        {' or contact us for assistance.'}
      </span>
      <ATBeaconButton
        className="pershing-error-message"
        variant={CTAVariants.Primary}
        onBeaconEventClick={() => window.location.assign(contactUsUrl)}
      >
        Contact US
      </ATBeaconButton>
    </div>
  );
}
